import { MATERIALS } from './profileData';

const fmt = value => `${Number(value.toFixed(1))} mm`;
const pathData = paths => paths.map(points => `M${points.map(([x, y]) => `${x.toFixed(2)},${(-y).toFixed(2)}`).join('L')}Z`).join('');

export const ProfileSvg = ({ part, title }) => {
  const { box, depth, height } = part, pad = Math.max(depth, height) * .16;
  const x0 = box.minX - pad, y0 = -box.maxY - pad, w = depth + pad * 2, h = height + pad * 2.5, s = Math.max(w, h) / 120;
  const bottom = -box.minY + pad * .55, left = box.minX - pad * .55;
  return <svg className="profile-svg" viewBox={`${x0} ${y0} ${w} ${h}`} role="img" aria-label={`${title}: ${fmt(depth)} wide by ${fmt(height)} high`} data-testid="profile-svg">
    <title>{title}</title>
    {part.components.map((c, i) => <path key={i} d={pathData(c.paths)} fill={MATERIALS[c.material]?.fill || MATERIALS.aluminium.fill} fillRule="evenodd" stroke="#0a1a17" strokeWidth={s * .25} data-material={c.material} />)}
    <g stroke="#e2b880" strokeWidth={s * .35} fill="none">
      <path d={`M${box.minX},${bottom}H${box.maxX}M${box.minX},${bottom - s * 2}v${s * 4}M${box.maxX},${bottom - s * 2}v${s * 4}`} />
      <path d={`M${left},${-box.maxY}V${-box.minY}M${left - s * 2},${-box.maxY}h${s * 4}M${left - s * 2},${-box.minY}h${s * 4}`} />
    </g>
    <g fill="#f7f2e8" fontSize={s * 4} fontFamily="Nunito, sans-serif">
      <text x={(box.minX + box.maxX) / 2} y={bottom + s * 6} textAnchor="middle" data-testid="profile-depth-label">{fmt(depth)}</text>
      <text x={left - s * 3} y={-(box.minY + box.maxY) / 2} textAnchor="middle" transform={`rotate(-90 ${left - s * 3} ${-(box.minY + box.maxY) / 2})`} data-testid="profile-height-label">{fmt(height)}</text>
    </g>
  </svg>;
};
